import { BasicTable, MASK_BOOLEAN_ICON } from "../../theme/Component/BasicTable";
import useModal, { MODAL_LG, MODAL_md, MODAL_XL } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import { PrintJson } from "../../theme/Component/PrintJson";

interface Props{
    name:string;
    list:any;
}
export const XlsxFormatTable=({name,list}:Props)=>{

    const modal = useModal("Formato",MODAL_XL);

     const head = [
        {title:'Propiedad',property:'Property',visible:true},
        {title:'Tipo',property:'Type',visible:true},
        {title:'Nombre',property:'Name',visible:true},
        {title:'Requerido',property:'Required',visible:true,mask:MASK_BOOLEAN_ICON}        
    ]

    return(
        <div className="row">
            <div className="col">
                <label>{name ?? 'Formato'}</label>
                <input type="text" placeholder="click para formato" name="Formato" className="form-control cursor" readOnly onClick={()=>{modal.open()}} />
            </div>
            <div className="col">
                <Modal modal={modal.modal} updateModal={modal.setModal}>                    
                    <BasicTable head={head} body={list} rowSet={()=>{}}></BasicTable>
                </Modal>
            </div>
        </div>
    )
}